import { Router } from "./routes";
import { Helmet } from "react-helmet";

function App() {
  // document.addEventListener("contextmenu", (event) => event.preventDefault());
  return (
    <div className="App">
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
        />
      </Helmet>
      <Router />
    </div>
  );
}

export default App;
